import { ErrorState } from "$components/error-state";
import { LoadingPage } from "$components/loading/loading-page";
import { useLocation } from "react-router-dom";
import { MultipleTabsErrorPage } from "./multiple-tabs-error-page";
import { useTabLeadership } from "./provider";

// Auth plumbing writes no RxDB data, and sign-out is the escape hatch from a
// tab the user cannot otherwise use.
const UNGATED_PATHS = ["/login", "/sign-out", "/auth0"];

const isUngated = (pathname: string) =>
  UNGATED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );

export const TabLeadershipGate: FCwC = ({ children }) => {
  const { isLeader, isElecting, error } = useTabLeadership();
  const { pathname } = useLocation();

  if (isUngated(pathname)) {
    return <>{children}</>;
  }

  if (isElecting) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <ErrorState
        title="Elephant could not check for other open tabs"
        body="Close any other Elephant tabs and try again. This keeps clinical records safe and consistent."
        showRetry
      />
    );
  }

  if (!isLeader) {
    return <MultipleTabsErrorPage />;
  }

  return <>{children}</>;
};
